import API from "./axios";

const vendorApi = {
  getAll:   ()          => API.get("/vendors"),
  /** Phase 5 — paged register. params: { page, size, sortBy, sortDir, q, isActive } */
  paged:    (params)    => API.get("/vendors/paged", { params }),
  getById:  (id)        => API.get(`/vendors/${id}`),
  create:   (data)      => API.post("/vendors", data),
  update:   (id, data)  => API.put(`/vendors/${id}`, data),
  toggle:   (id)        => API.patch(`/vendors/${id}/toggle-status`),
  delete:   (id)        => API.delete(`/vendors/${id}`),

  // ─── BRANCHES ───────────────────────────────────────────────────────────
  // A vendor's places of business — one address and GSTIN each, ONE ledger for
  // all of them. Nested under the vendor because a branch has no meaning apart
  // from it.
  //
  // activeOnly=true is for DOCUMENT PICKERS: an inactive branch must not be
  // selectable on a new purchase order, but must stay visible on the vendor
  // master so it can be reactivated.
  branches:       (vendorId, activeOnly = false) =>
    API.get(`/vendors/${vendorId}/branches`, { params: { activeOnly } }),
  createBranch:   (vendorId, data) => API.post(`/vendors/${vendorId}/branches`, data),
  // No vendorId in the update/delete paths — a branch cannot move between
  // vendors, since that would silently relocate every document raised on it.
  updateBranch:   (branchId, data) => API.put(`/vendors/branches/${branchId}`, data),
  deleteBranch:   (branchId)       => API.delete(`/vendors/branches/${branchId}`),
};

export default vendorApi;